import { type FC } from 'react'
import { type StripeCardElementChangeEvent, type TokenResult } from '@stripe/stripe-js'
import { makeTextFieldAutoFocus, TextField } from 'shared/ui/TextField'
import { Label } from 'shared/ui/Label'
import { StripeCardInput } from 'shared/ui/StripeCardInput'
import { Alert, Error, InputCheckbox } from 'shared/ui'
import { type ITooltipProps } from 'shared/ui/Tooltip'
import styles from './styles.module.scss'

export type ICardFormFieldsPrimaryCheckbox = {
  checked: boolean
  onChecked: () => void
  label: string
  questionTooltipProps?: ITooltipProps
  className?: string
}

export type ICardFormFieldsProps = {
  name: string
  setName: (value: string) => void
  nameError: string
  cardError: string
  apiError: boolean
  onChangeCard: (event: StripeCardElementChangeEvent) => void
  setOnSubmit: (onSubmit: () => Promise<TokenResult | undefined>) => void
  clearCardError: () => void
  primaryCheckbox?: ICardFormFieldsPrimaryCheckbox
  withFocus?: boolean
}

export const CardFormFields: FC<ICardFormFieldsProps> = ({
  name,
  setName,
  nameError,
  cardError,
  apiError,
  onChangeCard,
  setOnSubmit,
  clearCardError,
  primaryCheckbox,
  withFocus = true,
}) => (
  <div className={styles.wrap}>
    {apiError && (
      <Alert
        item={{
          type: 'error',
          title: 'Your card was declined',
          desc: 'Please select a different card',
        }}
        marginBottom={16}
      />
    )}
    <div className={styles.section}>
      <Label
        label={{
          text: 'Cardholder name',
        }}
      />
      <TextField
        value={name}
        onChange={(value) => setName(value)}
        InputProps={{
          placeholder: 'e.g. Adam Johnson',
        }}
        variant={'stroke'}
        size={'medium'}
        error={nameError}
        mainActions={[makeTextFieldAutoFocus({ withFocus })]}
      />
      <Error type={'text'} error={nameError} />
    </div>
    <div className={styles.section}>
      <Label
        label={{
          text: 'Card',
        }}
      />
      <StripeCardInput
        onChange={onChangeCard}
        setOnSubmit={setOnSubmit}
        onFocus={clearCardError}
        isError={!!cardError}
      />
      <Error type={'text'} error={cardError} />
    </div>
    {primaryCheckbox && <InputCheckbox {...primaryCheckbox} />}
  </div>
)
